module.exports = __webpack_public_path__ + "img/1.109866a1.jpg";